import { PortalModel } from "@apps/mf-overview/src/server/portals/model";

export enum PortalSortMethods {
  LEXICOGRAPHIC,
  GRADE_LEVEL,
}

export function sort(
  portals: PortalModel[],
  sortBy: PortalSortMethods
): PortalModel[] {
  return portals.sort((a, b) => {
    switch (sortBy) {
      case PortalSortMethods.LEXICOGRAPHIC:
        return a.title.toLowerCase().localeCompare(b.title.toLowerCase());

      case PortalSortMethods.GRADE_LEVEL:
        // In case a portal does not have any levels associated to them, then
        // display them last.
        const primarySort = (a.levels[0] ?? 9999) - (b.levels[0] ?? 9999);

        if (primarySort !== 0) {
          return primarySort;
        }

        // In case the first level matches, then sort based on the largest level
        // of the portal
        return (
          (a.levels[a.levels.length - 1] ?? 9999) -
          (b.levels[b.levels.length - 1] ?? 9999)
        );
    }
  });
}
